export default __webpack_public_path__ + "static/media/oaks-lab.5c3cd8e0.png";